var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component)?_c(_vm.component,{tag:"component",attrs:{"nodeId":_vm.nodeId,"node":_vm.node,"showBack":_vm.showPrevious,"isLast":_vm.isLast},on:{"previous":_vm.onPrevious,"end":_vm.onEnd}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }